import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularCorporateActionNotification: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_corporate-action-notification"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="corporate-action-notification icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M9.33789 3.5H15.8379C16.2176 3.5 16.5314 3.78215 16.581 4.14823L16.5879 4.25V7.5H18.3379C20.1328 7.5 21.5879 8.95507 21.5879 10.75V17.25C21.5879 19.0449 20.1328 20.5 18.3379 20.5H6.83789C5.04297 20.5 3.58789 19.0449 3.58789 17.25V10.75C3.58789 8.95507 5.04297 7.5 6.83789 7.5H8.58789V4.25C8.58789 3.8703 8.87004 3.55651 9.23612 3.50685L9.33789 3.5H15.8379H9.33789ZM18.3379 9H6.83789C5.87139 9 5.08789 9.7835 5.08789 10.75V17.25C5.08789 18.2165 5.87139 19 6.83789 19H18.3379C19.3044 19 20.0879 18.2165 20.0879 17.25V10.75C20.0879 9.7835 19.3044 9 18.3379 9ZM15.0879 5H10.0879V7.5H15.0879V5Z" />
      </svg>
    </span>
  );
};

export { RegularCorporateActionNotification };
